package top.wcpe.allincore.ui.runtime.render

import top.wcpe.allincore.layout.engine.Box
import top.wcpe.allincore.ui.runtime.element.UIElement
import top.wcpe.allincore.ui.runtime.render.UiRenderBridge

/**
 * 单选组容器渲染器：委托给 [BoxRenderer]。
 */
class RadioGroupRenderer : Renderer {

    private val delegate = BoxRenderer()

    override fun render(element: UIElement<*>, box: Box, bridge: UiRenderBridge) {
        delegate.render(element, box, bridge)
    }
}
